import _extends from "@babel/runtime/helpers/extends";
/**
 * This file generated by Stencil generateIcons scripts
 * DO NOT EDIT DIRECTLY
 */

import React from 'react';
import { withIconProps } from '../utils/withIconProps';
import { jsx as ___EmotionJSX } from "@emotion/react";
const IconArrowLeftExtraSmall = withIconProps(props => {
  return ___EmotionJSX("svg", _extends({
    width: "16px",
    height: "16px",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), ___EmotionJSX("path", {
    d: "M6.70711 4.70711C7.09763 4.31658 7.09763 3.68342 6.70711 3.29289C6.31658 2.90237 5.68342 2.90237 5.29289 3.29289L1.29289 7.29289C0.902369 7.68342 0.902369 8.31658 1.29289 8.70711L5.29289 12.7071C5.68342 13.0976 6.31658 13.0976 6.70711 12.7071C7.09763 12.3166 7.09763 11.6834 6.70711 11.2929L4.41421 9H14C14.5523 9 15 8.55228 15 8C15 7.44772 14.5523 7 14 7H4.41421L6.70711 4.70711Z",
    fill: "currentColor"
  }));
}, 'IconArrowLeftExtraSmall');
IconArrowLeftExtraSmall.displayName = 'IconArrowLeftExtraSmall';
export default IconArrowLeftExtraSmall;